export const sectionsSidebarSign = {
  SIGN: 'sign',
  SIGNATORIES: 'signatories',
  FIEL: 'fiel'
};
